module.exports = __webpack_public_path__ + "static/media/mod_cod4_surf_5.88f4c701.jpg";